<template>
    <!-- <div class="reason">
        <global-svg type="sun" color="#758483" width="12px" height="12px" class="reason-icon"></global-svg>
        <span class="popover">{{ fetchPrimaryArticle(slug).reason.note }}</span>
    </div> -->
	<div class="intro-reason" v-if="fetchPrimaryArticle(slug).reason && fetchPrimaryArticle(slug).reason.note">
		<span>{{ fetchPrimaryArticle(slug).reason.note }}</span>
	</div>
</template>

<script>
    import { Mixins } from '../mixins'

    export default {
        props: ['slug'],
        mixins: [Mixins],
        methods: {}   
    }
</script>

<style lang="scss" scoped>
	@import '~styles/_variables';
	
	.intro-reason {
		margin: 10px 0 14px 0;
		color: $base-primary;
		background: $highlight-primary;
		padding: 5px;
		border-radius: $border-radius;
		font-size: 12px;
		line-height: 1.4;
	}


	// Ongoing

    .reason {
        position: absolute;
        right: 0;
        bottom: -42px;
        z-index: 2;
    }

    .popover {
		width: 180px;
		border-radius: 5px;
		background-color: rgb(51, 63, 82);
		text-align: center;
		line-height: 1.5;
		display: block;
		color: $white-primary;
		font-size: 12px;
		position: absolute;
		bottom: 25px;
		left: 50%;
		margin-left: -90px;
        padding: 10px;
		opacity: 1;
		visibility: visible;
		transition: all 0.2s ease-in-out;
		font-weight: bold;
		z-index: 3;
		&::after {
			top: 100%;
			left: 50%;
			border: solid transparent;
			content: " ";
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
			border-color: rgba(0, 0, 0, 0);
			border-top-color: rgb(51, 63, 82);
			border-width: 7px;
			margin-left: -7px;
		}
	}
	.reason:hover .popover {
		opacity: 1;
		visibility: visible;
	}

</style>